import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Link } from '@tanstack/react-router'
import { dashboardQueries } from '@/api/endpoints/dashboard'
import { apiErrorMessage } from '@/api/errors'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { formatDisplayDateTime } from '@/lib/dates'
import { DASHBOARD_CARDS } from '@/features/dashboard/dashboard-cards'

export const Route = createFileRoute('/_authed/')({
  loader: ({ context }) => context.queryClient.prefetchQuery(dashboardQueries.counts()),
  component: Dashboard,
})

function Dashboard() {
  const { data, isLoading, isError, error } = useQuery(dashboardQueries.counts())

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold">Dashboard</h1>
      {isError && <p className="text-sm text-destructive">{apiErrorMessage(error)}</p>}
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {DASHBOARD_CARDS.map(({ key, title, link }) => {
          const content = (
            <Card className={link ? 'transition-colors hover:bg-accent' : undefined}>
              <CardHeader>
                <CardTitle className="text-sm font-medium text-muted-foreground">{title}</CardTitle>
              </CardHeader>
              <CardContent>
                {isLoading ? (
                  <Skeleton className="h-9 w-16" />
                ) : (
                  <p className="text-3xl font-semibold">{data?.[key] ?? '—'}</p>
                )}
              </CardContent>
            </Card>
          )
          return link ? (
            <Link
              key={key}
              to={link.to}
              search={link.search}
              className="block rounded-xl outline-none focus-visible:ring-2 focus-visible:ring-ring"
            >
              {content}
            </Link>
          ) : (
            <div key={key}>{content}</div>
          )
        })}
      </div>
      {data?.generated_at && (
        <p className="text-xs text-muted-foreground">
          Counts as of {formatDisplayDateTime(data.generated_at)}
        </p>
      )}
    </div>
  )
}
